<template>
  <div>
    <v-data-table
    :headers="headers"
    :items="users"
    :search="search"

    class="elevation-1 text-capitalize"
    >
    <template v-slot:top>
      <v-toolbar text color="white">
        <v-toolbar-title>Users</v-toolbar-title>
        <v-divider
        class="mx-2"
        inset
        vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.superAdmin="{ item }">
     <v-icon
     v-if="item.superAdmin" medium class="d-inline" color="primary">
     check
   </v-icon>
 </template>
 <template v-slot:item.admin="{ item }">
   <v-icon v-if="item.admin" medium class="d-inline" color="primary">
     check
   </v-icon>
 </template>

 <template v-slot:item.action="{ item }">
  <v-btn v-if="item.admin" @click="toggleAdmin(item, false)" class="ml-3 mt-1" color="info" > 
    <v-icon medium class="d-inline pr-2" > check </v-icon>
    Admin
  </v-btn>

  <v-btn v-if="!item.admin" @click="toggleAdmin(item, true)" class="ml-3 mt-1" color="success" dark>
    <v-icon medium class="d-inline pr-2"> check_box_outline_blank </v-icon> 
    Admin 
  </v-btn>

  <v-btn v-if="$store.state.user.superAdmin" @click="preDelete(item)" color="#D32F2F" dark class="ml-3 mt-1">
    <v-icon medium class="darken-4 d-inline pr-1"> delete </v-icon>
    Delete
  </v-btn>
</template>

<template v-slot:no-data>
  <div class="text-xs-center">
    Your Employees will appear here
  </div>
</template>
</v-data-table>
<template>
  <div class="text-center">
    <v-dialog
    v-model="loading"
    hide-overlay
    persistent
    width="300"
    >
    <v-card
    color="primary"
    dark
    >
    <v-card-text>
      Hang On A Sec...
      <v-progress-linear
      indeterminate
      color="white"
      class="mb-0"
      ></v-progress-linear>
    </v-card-text>
  </v-card>
</v-dialog>
</div>
</template>

<template>
  <v-dialog
  v-model="deleteDialog"
  max-width="340"
  >    
  <v-card>
    <v-card-title class="title">Delete User</v-card-title>
    <v-card-text>
      Are You Sure You Want To Destroy This User {{user.firstName}} {{user.lastName}}?
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
      color="primary darken-1"
      text
      @click="deleteDialog = false"
      >
      Cancel
    </v-btn>

    <v-btn
    color="#D32F2F"
    text
    @click="deleteDialog = false, deleteUser()"
    >
    Delete
  </v-btn>
</v-card-actions>
</v-card>
</v-dialog>
</template>
</div>
</template>
<script>
import firebase from '@/helpers/firebaseConfig'
const db = firebase.firestore()
const functions = firebase.functions()

import router from '../router'

export default {
  data() {
    return{
      user: {},
      deleteDialog: false,
      loading: false,
      name: "users",
      headers: [
      { text: 'Name', value: 'firstName' },
      { text: 'Last Name', value: 'lastName' },
      { text: 'Service', value: 'service' },
      { text: 'Email', value: 'email' },
      { text: 'Super Admin', value: 'superAdmin' },
      { text: 'Admin', value: 'admin' },
      { text: 'Admin Actions', value: 'action', sortable: false },
      ],
      search: ''
    }
  },
  computed: {
    users(){
      return this.$store.getters.users
    }
  },
  methods: {

    toggleAdmin (user, bool) {

      if (this.$store.state.user.admin == false){
        return this.$store.commit('setSnack', "Only Admins Can Change Admin Privelages❗️")
      }
      if (user.id == this.$store.state.user.id){
        return this.$store.commit('setSnack', '🤪 😂 You Can\'t Change Your Own Admin Privelages❗️')
      } 
      if (user.superAdmin){
        return this.$store.commit('setSnack', 'You Cant Change The Super Admin!')
      }
      if (this.$store.state.user.admin && !user.superAdmin) {
        this.loading = true
        const adminEmail = user.email
        const adminToggle = functions.httpsCallable('adminToggle')

        adminToggle({ email: adminEmail, bool: bool }).then(result => {
          if (result.data.error) {
            this.loading = false
            this.$store.commit('setSnack', result.data.error) 
          } 
          if (result.data.success){
            this.loading = false
            this.$store.commit('setSnack', result.data.success)
          }
          // console.log(result)
        })
      } else {
        this.$store.commit('setSnack', "There Was An Authorization Problem")
        this.loading = false
      }
    },
    preDelete (user) {
      if (!this.$store.state.user.superAdmin){
        return this.$store.commit('setSnack', ' Only Super Admins Can Delete Users❗️')
      }
      if (user.id == this.$store.state.user.id){
        this.$store.commit('setSnack', ' 😱 Don\'t Delete Your Self❗️')
      } else {
        this.deleteDialog = true
        this.user = user

        // const index = this.users.indexOf(user)
        // confirm('Are you sure you want to destroy this user?') && this.deleteUser(user)
      }
    },
    deleteUser(){
      let user = this.user      
      if (user.id == 'pDsqveIUF0eQi16ukLGwqqCOzJ43'){
        return this.$store.commit('setSnack', ' 😱 You Cant Destroy The Creator❗️')
      } else {
        const deleteUser = functions.httpsCallable('deleteUser')

        deleteUser({uid: user.id, firstName: user.firstName, lastName: user.lastName })
        .then(result => {
          if (result.data == null){  
            // succussfully deleted user and now deleting data
            db.collection('users').doc(user.id).delete()
            // delete presets
            db.collection('presets').where('userId', '==', user.id).get()
            .then((querySnapshot)=> {
              querySnapshot.forEach((doc)=> {
                doc.ref.delete()
              })
            }).catch(err=>{
              console.log('error deleting presets')
            })
            // delete history
            db.collection('history').where('userId', '==', user.id).get()
            .then((querySnapshot)=> {
              querySnapshot.forEach((doc)=> {
                doc.ref.delete()
              })
            }).catch(err=>{
              console.log('error deleting history')
            })
          this.$store.commit('setSnack', `User ${user.firstName} ${user.lastName} Was Destroyed Successfully! `)
          } 
          if (result.data.error){
            this.$store.commit('setSnack', result.data.error)
          }
        }).catch(err=>{
          console.log('there is an error', err)
        })
      }
    }
  }
}
</script>